// The purse as the masthead hears about it.
//
// Coin arrives from several directions: the wire (PurseChannel, on every
// write to the User's silver or gold), a page's own JSON answer (a shift's
// pay carries `purse`, a purchase carries `silver`/`gold`), or a controller
// that already knows the new balance and says so on the document
// ("purse:changed"). All of them are read here into one shape.

// { silver, gold } with only the coins the payload actually named, as
// integers; null when the payload names neither. A payload that says
// `purse: {...}` is unwrapped; one that carries a balance at the top level
// is read there. Anything that is not a whole number is ignored, so a
// payload's unrelated "gold: true" flag cannot zero the purse.
export function readPurse(payload) {
  if (!payload || typeof payload !== "object") return null

  const source = payload.purse && typeof payload.purse === "object" ? payload.purse : payload
  const purse = {}
  for (const coin of [ "silver", "gold" ]) {
    const value = source[coin]
    const number = typeof value === "string" ? Number(value) : value
    if (Number.isInteger(number) && number >= 0) purse[coin] = number
  }

  return Object.keys(purse).length > 0 ? purse : null
}

// Which coins moved, given what the chip showed and what it now hears. The
// chip ticks for these and not for a repeat of the same numbers (the wire
// catches up on subscribe with what the page already drew).
export function changedCoins(shown, heard) {
  if (!heard) return []

  return Object.keys(heard).filter((coin) => shown?.[coin] !== heard[coin])
}
